var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clientFiltersHome" },
    [
      !_vm.filterId
        ? _c("FilterList", {
            attrs: {
              projectName: _vm.projectName,
              searchQuery: _vm.searchQuery,
              regexSearch: _vm.regexSearch
            }
          })
        : _c("FilterDetails", {
            attrs: {
              projectName: _vm.projectName,
              filterId: parseInt(_vm.filterId),
              searchQuery: _vm.searchQuery,
              regexSearch: _vm.regexSearch
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }